export const FEEDBACKS = "FEEDBACKS";
export const FEEDBACK_COUNT = "FEEDBACK_COUNT";
export const FEEDBACK_SEL = "FEEDBACK_SEL";
